import React, { useContext } from 'react';
import { Outlet } from 'react-router-dom';
import { SiteProvider } from 'providers/site';

import SiteProposalHeader from './components/header';
import SiteProposalFooter from './components/footer';
import { IsFullScreenContext } from 'routing';

const SiteProposalFlow = () => {
  const isFullScreen = useContext(IsFullScreenContext);

  return (
    <SiteProvider>
      <SiteProposalHeader />
      <div>
        <Outlet />
      </div>
      <div style={{ marginTop: isFullScreen ? 0 : '168px' }}>
        <SiteProposalFooter />
      </div>
    </SiteProvider>
  );
};

export default SiteProposalFlow;